import * as KendraPluginActions from './kendraPlugin.reducer'

export const { setKendraPluginState } = KendraPluginActions
